import React from 'react';
import '../styles/FAQSection.css';

const homeFaqs = [
  {
    question: 'What is a Cheetah typing test rank?',
    answer: 'Cheetah is the Expert typing rank on Type Click Tests: 401–500 characters per minute (about 80–100 WPM). Take any typing test on this site to see whether you rank Snail, Turtle, Rabbit, Wolf, Cheetah, or Falcon.',
  },
  {
    question: 'What is a Turtle typing test rank?',
    answer: 'Turtle is the Novice rank: 101–200 CPM (about 20–40 WPM). It is a typing speed rank, not a CPS click-test rank. Start with the 15-second or 1-minute typing test to get yours.',
  },
  {
    question: 'What is CPM in a typing test?',
    answer: 'CPM is characters per minute, including spaces. WPM is CPM divided by five. This site reports both after every typing test.',
  },
  {
    question: 'Is a CPS test the same as a typing test?',
    answer: 'No. A typing test measures WPM and CPM on a keyboard. A CPS test measures clicks per second on a mouse or trackpad. Use the 5-second CPS test if you want click speed, not typing speed.',
  },
];

const typingFaqs = [
  {
    question: 'What is CPM in typing?',
    answer: 'CPM stands for Characters Per Minute. It measures the number of characters you can type correctly in one minute, including spaces and punctuation.',
  },
  {
    question: 'What is WPM in typing?',
    answer: 'WPM stands for Words Per Minute. It measures the number of words you can type correctly in one minute. A standard word is typically considered to be 5 characters (including spaces).',
  },
  {
    question: 'What is average CPM in typing?',
    answer: 'Average CPM varies greatly depending on age, experience, and profession. For a casual typist, it might be around 200-300 CPM (40-60 WPM). For professional typists, it can be 400+ CPM (80+ WPM).',
  },
  {
    question: 'What is average WPM in typing?',
    answer: 'The average typing speed is typically around 40 WPM. However, this can range from 20 WPM for beginners to over 75 WPM for experienced typists.',
  },
  {
    question: 'What is good CPM typing speed?',
    answer: 'A good CPM typing speed is generally considered to be above 350 CPM (70 WPM). Speeds above 450 CPM (90 WPM) are often considered excellent.',
  },
  {
    question: 'What is good WPM typing speed?',
    answer: 'A good WPM typing speed is generally considered to be above 70 WPM. Speeds of 90 WPM or higher are considered excellent and are often required for professions like transcription.',
  },
  {
    question: 'Is typing 40 WPM good?',
    answer: 'Typing 40 WPM is considered an average speed. It\'s a good starting point for most daily tasks, but there\'s room for improvement, especially for professional roles.',
  },
  {
    question: 'Is typing 70 words a minute fast?',
    answer: 'Yes, typing 70 WPM is considered a fast typing speed. This speed is well above average and proficient for most professional tasks.',
  },
  {
    question: 'Is a 120 WPM typing speed good?',
    answer: 'Typing at 120 WPM is an excellent and very fast typing speed. This speed is typically achieved by professional typists and is considered expert level.',
  },
  {
    question: 'Is 75 WPM a fast typing speed?',
    answer: 'Yes, 75 WPM is definitely a fast typing speed. It is considered a very efficient speed for most computer-based tasks.',
  },
];

const clickFaqs = [
  {
    question: 'What is CPS in clicking?',
    answer: 'CPS stands for Clicks Per Second. It measures how many times you can click your mouse button in one second.',
  },
  {
    question: 'What is average CPS in clicking?',
    answer: 'Average CPS varies depending on the test duration and clicking method. For a quick test (like 1s or 5s), averages might be higher (around 5-7 CPS). Over longer durations (like 60s), the average might be lower (around 4-6 CPS).',
  },
  {
    question: 'What is good CPS clicking speed?',
    answer: 'A good CPS varies by duration, but generally, speeds consistently above 7 CPS are considered good, and speeds above 10 CPS are excellent, especially over longer durations.',
  },
  {
    question: 'What is a click test?',
    answer: 'A click test (or CPS test) measures how many clicks per second (CPS) you can achieve with your mouse. It\'s used to evaluate clicking speed and consistency, often for gaming or general mouse dexterity.',
  },
  {
    question: 'What is the purpose of a click test?',
    answer: 'The purpose of a click test is to measure and improve your clicking speed and accuracy. It\'s popular among gamers (especially for genres requiring rapid clicks), but also useful for assessing general mouse control and endurance.',
  },
  {
    question: 'How to do a click test?',
    answer: 'To do a click test, simply click the designated area on the screen as many times as you can within the given time limit. The test begins with your first click. Your score will be calculated as Clicks Per Second (CPS).',
  },
  {
    question: 'Is a CPS test a typing test?',
    answer: 'No. CPS is clicks per second. WPM and CPM are typing metrics. If you searched for a typing test, use the 15-second or 1-minute typing test instead of this click test.',
  },
];

const colorMemoryFaqs = [
  {
    question: 'How does Color Memory work?',
    answer: 'A random color is shown for 5 seconds. After it disappears, use the hue, saturation, and lightness sliders to recreate it from memory. Score 95 or higher to earn a point and get a new color. Below 95 ends the run.',
  },
  {
    question: 'How is the score calculated?',
    answer: 'Each guess gets an accuracy score from 0 to 100 based on how close it is to the target color in RGB space. A perfect match is 100. You only score a streak point at 95 or higher — close-ish does not count.',
  },
  {
    question: 'Is there a time limit for picking a color?',
    answer: 'No. You only have 5 seconds to memorize the color. After that, take as long as you need to adjust the sliders before submitting.',
  },
  {
    question: 'Is my best score saved?',
    answer: 'Yes. Your best streak (points in a single run) is stored in this browser with local storage so you can try to beat it later on the same device.',
  },
];

const higherOrLowerFaqs = [
  {
    question: 'How do you play Higher or Lower?',
    answer: 'The center prompt asks “Which number is higher?” or “Which number is lower?” Click the side with the bigger or smaller number. Each card shows a country with population, territory size, or an animal count such as pigeons in Italy.',
  },
  {
    question: 'Can population, territory size, and animal counts be compared in one round?',
    answer: 'Yes. You compare the numbers only. For example, Poland’s territory size might be 312,696 and pigeons in Italy about 4,800,000 — pigeons are higher because 4,800,000 is the bigger number, even though the labels are different.',
  },
  {
    question: 'Where does the population data come from?',
    answer: 'The game uses approximate 2024 United Nations and World Bank population estimates. Figures are rounded snapshots, so they may differ slightly from the latest census or live counters.',
  },
  {
    question: 'Where do territory size figures come from?',
    answer: 'Country territory sizes come from standard geographic references, measured in square kilometers (km²). You still compare the raw numbers against population figures and animal counts.',
  },
  {
    question: 'Where do the animal counts come from?',
    answer: 'Animal counts are approximate published or widely cited estimates — FAO livestock inventories, pet-owner surveys, and national wildlife counts. They are snapshots, not live censuses, and are here for the number-comparison game.',
  },
  {
    question: 'Is my highscore saved?',
    answer: 'Yes. Your best score is stored in this browser with local storage, so you can come back later and try to beat it on the same device.',
  },
  {
    question: 'Can I play Higher or Lower on mobile?',
    answer: 'Yes. Tap the left or right side. On a keyboard you can also use the left and right arrow keys.',
  },
];

const stopTheWheelFaqs = [
  {
    question: 'How do you play Stop the Wheel?',
    answer: 'There are 30 levels. Stop the wheel when the purple target zone lines up with the pointer at the top. Hit the sector to clear the level and move on. Miss once and the run is over — you start again from level 1.',
  },
  {
    question: 'How is the score calculated?',
    answer: 'A perfect alignment with the center of the target zone scores up to 100. The farther you are from the target center in degrees, the lower your score. You still need to land inside the purple sector to advance.',
  },
  {
    question: 'Does the wheel get harder each level?',
    answer: 'Yes. Early levels already spin quickly. Each later level shrinks the sector and spins the wheel faster. Level 30 is tight but still hittable if you time it.',
  },
  {
    question: 'Is my progress saved?',
    answer: 'Your best level cleared and best score are stored in this browser. A miss resets the current run to level 1.',
  },
];

const guessTheCountryFaqs = [
  {
    question: 'How do you play Guess the Country?',
    answer: 'A statement appears above the map — a capital, landmark, or geography fact. Click the country it describes. A correct click scores a point and loads the next clue. One wrong country ends the run.',
  },
  {
    question: 'Can I zoom the map?',
    answer: 'Yes. Use the + and − buttons, the scroll wheel, or pinch on a phone. Drag the map at any zoom — including 100% — to reach countries at the edges.',
  },
  {
    question: 'Is my highscore saved?',
    answer: 'Yes. Your best streak is stored in this browser with local storage, so you can come back later and try to beat it on the same device.',
  },
  {
    question: 'Do the clues repeat?',
    answer: 'There are more than 30 distinct statements. The game shuffles them and avoids repeating the same clue immediately.',
  },
];

const whichCountryIsGayerFaqs = [
  {
    question: 'How do you play Which Country Is Gayer?',
    answer: 'Two country cards each show one number — Rainbow Index, Equality Index, legal protection score, marriage-equality year, or estimated LGBT+ identification/population. The center asks which is gayer (higher number) or less gay (lower number). Click that side. The winner stays; a new challenger appears. One wrong pick ends the run.',
  },
  {
    question: 'Can different metrics be compared in one round?',
    answer: 'Yes. You compare the printed numbers only, the same way Higher or Lower mixes population and territory size. Spain’s Rainbow Index 89 beats Nigeria’s Equality Index 11 because 89 is larger — even though the labels differ.',
  },
  {
    question: 'Why does it sometimes ask “less gay”?',
    answer: 'If the card that stays is already the friendliest country in the deck, “gayer” would have no correct answer. Asking for the lower number lets the streak continue downward.',
  },
  {
    question: 'Where does the data come from?',
    answer: 'Rainbow Index scores are ILGA-Europe Rainbow Map 2026 (Europe, 0–100). Equality Index and Legal Index are Equaldex mid-2026 snapshots (global, 0–100). LGBT+ identification percentages are approximate Ipsos Pride 2024 figures for surveyed countries; estimated population multiplies that percent by UN/World Bank 2024 population. Marriage years are first nationwide same-sex marriage dates. Snapshots, not live APIs — labeled as approximate.',
  },
  {
    question: 'Is this ranking who is “actually gay”?',
    answer: 'No. It is a number-comparison game using public LGBT-rights and survey metrics — laws, indexes, and self-identification rates — not stereotypes, nightlife rumors, or insults.',
  },
  {
    question: 'Is my highscore saved?',
    answer: 'Yes. Your best streak is stored in this browser with local storage, so you can try to beat it later on the same device.',
  },
];

const reactionTestFaqs = [
  {
    question: 'How does the F1 reaction test work?',
    answer: 'Five red lights come on one by one, about a second apart, like an F1 start gantry. After all five are lit, they go out after a random delay. Click, tap, or press Space the moment the lights go out.',
  },
  {
    question: 'What is a jump start?',
    answer: 'A jump start (false start) happens if you click while any red lights are still on. That attempt fails and no reaction time is saved. Wait for lights out.',
  },
  {
    question: 'What is a good reaction time?',
    answer: 'F1 drivers typically launch in about 150–250 ms. Under 250 ms is a solid start on this test. Under 150 ms is very good for a human; under 120 ms is elite. Guessing early is a jump start and does not count.',
  },
  {
    question: 'Is this an F1 click test?',
    answer: 'Yes. It copies the Formula 1 start-lights sequence: five red lights, then they go out. Click, tap, or press Space the instant the lights go out. That is a reaction click, not a CPS click-speed test.',
  },
  {
    question: 'Is my best time saved?',
    answer: 'Yes. Your fastest valid reaction time is stored in this browser with local storage on the same device. Jump starts are not saved.',
  },
];

const FAQSection = ({ mode = 'typing' }) => {
  const faqs = mode === 'home'
    ? homeFaqs
    : mode === 'click'
    ? clickFaqs
    : mode === 'higherOrLower'
      ? higherOrLowerFaqs
      : mode === 'colorMemory'
        ? colorMemoryFaqs
        : mode === 'stopTheWheel'
          ? stopTheWheelFaqs
          : mode === 'reactionTest'
            ? reactionTestFaqs
            : mode === 'guessTheCountry'
              ? guessTheCountryFaqs
              : mode === 'whichCountryIsGayer'
                ? whichCountryIsGayerFaqs
                : typingFaqs;
  const title = mode === 'home'
    ? 'Typing Test FAQs'
    : mode === 'click'
    ? 'Click Test FAQs'
    : mode === 'higherOrLower'
      ? 'Higher or Lower FAQs'
      : mode === 'colorMemory'
        ? 'Color Memory FAQs'
        : mode === 'stopTheWheel'
          ? 'Stop the Wheel FAQs'
          : mode === 'reactionTest'
            ? 'F1 Reaction Test FAQs'
            : mode === 'guessTheCountry'
              ? 'Guess the Country FAQs'
              : mode === 'whichCountryIsGayer'
                ? 'Which Country Is Gayer? FAQs'
                : 'Typing Test FAQs';

  return (
    <section className="faq-section">
      <h2>{title}</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div className="faq-item" key={index}>
            <h3>{faq.question}</h3>
            <p>{faq.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
export { homeFaqs, higherOrLowerFaqs, colorMemoryFaqs, stopTheWheelFaqs, reactionTestFaqs, guessTheCountryFaqs, whichCountryIsGayerFaqs }; 